import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'aimIntegrations'>;
};

export const AimIntegrationsSubTab = ({ formComposition }: Props) => (
  <div className='flex flex-col flex-1 gap'>
    {formComposition.renderGroup('aimIntegrations')}
  </div>
);
